export default "__VITE_ASSET__CH6XhirH__"